import type { MediaItem } from '@/types/media';

export const movies: MediaItem[] = [
  {
    id: 'm1',
    title: '星海归途',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20against%20a%20vast%20pink%20and%20rose%20nebula%20galaxy%2C%20soft%20warm%20lighting%2C%20dreamy%20artistic%20style%2C%20minimal%20clean%20background%2C%20high%20detail%20editorial%20photography&width=800&height=1200&seq=poster-movie-star-ocean&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.7,
    director: '陈望舒',
    cast: ['林知远', '苏晚晴', '周牧野'],
    synopsis: '一名失联多年的深空航行者意外收到来自地球的呼唤信号，在跨越星海的归途中，他重新审视了人类与故乡的意义。',
    hits: 128400,
    updatedAt: '2025-10-08',
  },
  {
    id: 'm2',
    title: '长安十二时',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20Chinese%20palace%20movie%20poster%20with%20elegant%20lanterns%2C%20misty%20morning%20light%2C%20rose%20and%20gold%20color%20palette%2C%20artistic%20painterly%20style%2C%20minimal%20composition%2C%20high%20detail&width=800&height=1200&seq=poster-movie-changan&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['古装', '悬疑', '剧情'],
    rating: 8.9,
    director: '顾清川',
    cast: ['沈砚舟', '白露微', '程之遥'],
    synopsis: '长安城一夜之间陷入离奇谜案，一位年轻书吏需在十二个时辰内抽丝剥茧，揭开隐藏在繁华之下的惊天秘密。',
    hits: 156200,
    updatedAt: '2025-09-28',
  },
  {
    id: 'm3',
    title: '暗夜追凶',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20with%20rainy%20neon%20city%20street%20at%20night%2C%20pink%20and%20mauve%20reflections%20on%20wet%20asphalt%2C%20moody%20atmospheric%20style%2C%20minimal%20clean%20composition&width=800&height=1200&seq=poster-movie-dark-night&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['犯罪', '悬疑', '惊悚'],
    rating: 8.4,
    director: '赵斯年',
    cast: ['陆锋', '许安宁', '范峻'],
    synopsis: '一桩尘封多年的悬案再度浮出水面，执着的刑警与沉默的证人之间展开了一场关于真相与救赎的漫长较量。',
    hits: 98400,
    updatedAt: '2025-10-05',
  },
  {
    id: 'm4',
    title: '山那边的风',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20literary%20drama%20movie%20poster%20of%20rolling%20green%20hills%20under%20soft%20sunset%2C%20warm%20pink%20haze%2C%20solitary%20figure%20walking%2C%20gentle%20artistic%20style%2C%20minimal%20serene%20composition&width=800&height=1200&seq=poster-movie-mountain-wind&orientation=portrait',
    year: 2023,
    region: '中国',
    genres: ['剧情', '文艺', '家庭'],
    rating: 8.2,
    director: '何知秋',
    cast: ['李叶', '宋怀山', '柳青禾'],
    synopsis: '一位城市青年回到偏远山村，在四季流转间重新认识了土地、亲情与自己的来处，也吹散了心头的迷雾。',
    hits: 64200,
    updatedAt: '2025-09-15',
  },
  {
    id: 'm5',
    title: '极速狂飙',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20action%20racing%20movie%20poster%20with%20sleek%20sports%20car%20drifting%2C%20motion%20blur%20light%20trails%20in%20pink%20and%20white%2C%20dramatic%20studio%20lighting%2C%20high%20energy%20minimal%20composition&width=800&height=1200&seq=poster-movie-speed&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['动作', '赛车', '运动'],
    rating: 8.1,
    director: '雷振东',
    cast: ['韩野', '温子琪', '石破军'],
    synopsis: '曾经的车王在低谷中重出江湖，为了赎回尊严，他必须在一个赛季里击败所有对手，也要战胜内心的阴影。',
    hits: 112700,
    updatedAt: '2025-10-01',
  },
  {
    id: 'm6',
    title: '时光信箱',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20fantasy%20movie%20poster%20with%20vintage%20mailbox%20among%20blooming%20cherry%20blossoms%2C%20soft%20pink%20petals%20falling%2C%20warm%20dreamy%20light%2C%20gentle%20artistic%20style%20minimal&width=800&height=1200&seq=poster-movie-time-letter&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['爱情', '奇幻', '剧情'],
    rating: 8.5,
    director: '温言',
    cast: ['江时序', '叶子澄', '顾南枝'],
    synopsis: '女孩偶然发现一个能寄信给过去的信箱，她试图改写一段遗憾的感情，却发现每一次改变都需要付出代价。',
    hits: 143900,
    updatedAt: '2025-09-22',
  },
  {
    id: 'm7',
    title: '深海迷航',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20sci-fi%20movie%20poster%20beneath%20deep%20ocean%20with%20glowing%20jellyfish%20and%20soft%20magenta%20light%20rays%2C%20mysterious%20atmospheric%20style%2C%20minimal%20elegant%20composition&width=800&height=1200&seq=poster-movie-deep-sea&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['冒险', '科幻', '灾难'],
    rating: 7.9,
    director: '龙一鸣',
    cast: ['秦海深', '罗雨薇', '焦阳'],
    synopsis: '一支深海科考队在海沟深处发现未知信号，当他们越走越深，也一步步逼近了人类从未触碰的禁区。',
    hits: 88600,
    updatedAt: '2025-09-30',
  },
  {
    id: 'm8',
    title: '一荤一素',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20warm%20comedy%20family%20movie%20poster%20with%20home%20cooked%20Chinese%20meal%20on%20wooden%20table%2C%20cozy%20soft%20pink%20light%2C%20heartwarming%20minimal%20artistic%20style&width=800&height=1200&seq=poster-movie-family-meal&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['喜剧', '家庭', '剧情'],
    rating: 8.3,
    director: '钱多福',
    cast: ['耿直', '马玉兰', '钱小满'],
    synopsis: '一家老餐馆面临拆迁，三代人在一荤一素的家常菜里，重新找回了被城市生活冲淡的亲情与温度。',
    hits: 75600,
    updatedAt: '2025-09-12',
  },
  {
    id: 'm9',
    title: '雪域孤鹰',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20action%20adventure%20movie%20poster%20of%20snow%20mountains%20with%20a%20lone%20climber%20silhouette%2C%20pale%20pink%20dawn%20sky%2C%20epic%20minimal%20moody%20style%2C%20high%20detail&width=800&height=1200&seq=poster-movie-snow-eagle&orientation=portrait',
    year: 2023,
    region: '中国',
    genres: ['动作', '冒险', '剧情'],
    rating: 8.0,
    director: '崔雪峰',
    cast: ['高原', '蓝雪', '穆朗'],
    synopsis: '一支登山队在暴风雪中失联，经验丰富的向导独自踏上搜救之路，在极限环境中与时间争夺生命。',
    hits: 59800,
    updatedAt: '2025-09-05',
  },
  {
    id: 'm10',
    title: '迷雾之城',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20thriller%20movie%20poster%20of%20a%20foggy%20city%20skyline%20at%20dusk%2C%20soft%20mauve%20and%20pink%20haze%20covering%20towers%2C%20atmospheric%20elegant%20minimal%20style&width=800&height=1200&seq=poster-movie-fog-city&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['悬疑', '惊悚', '犯罪'],
    rating: 8.6,
    director: '闻星野',
    cast: ['商宬', '李梧', '钟离'],
    synopsis: '连续失踪案让整座城市陷入迷雾，一位记者与一位退休警探联手追查，真相却比迷雾本身更加令人心悸。',
    hits: 103500,
    updatedAt: '2025-09-26',
  },
  {
    id: 'm11',
    title: '春风十里',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20movie%20poster%20with%20blooming%20street%20trees%20in%20a%20modern%20city%2C%20soft%20pink%20petals%20in%20the%20sunlight%2C%20warm%20fresh%20minimal%20artistic%20style&width=800&height=1200&seq=poster-movie-spring-city&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['爱情', '都市', '剧情'],
    rating: 7.8,
    director: '夏之光',
    cast: ['顾之遥', '许暖', '白昼'],
    synopsis: '两个在城市里奔波的年轻人在春天的地铁口相遇，一段关于理想、错过与重逢的故事就此展开。',
    hits: 69300,
    updatedAt: '2025-10-02',
  },
  {
    id: 'm12',
    title: '铁血山河',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20war%20history%20movie%20poster%20with%20distant%20mountains%20at%20sunset%2C%20warm%20amber%20and%20pink%20haze%2C%20solemn%20epic%20minimal%20artistic%20painterly%20style&width=800&height=1200&seq=poster-movie-war-history&orientation=portrait',
    year: 2023,
    region: '中国',
    genres: ['战争', '历史', '剧情'],
    rating: 8.8,
    director: '岳崇山',
    cast: ['铁牧', '何守疆', '沈靖'],
    synopsis: '战火纷飞的年代，一群普通人在家国大义前做出抉择，用血肉之躯守护身后的山河与百姓。',
    hits: 134800,
    updatedAt: '2025-08-28',
  },
];

export const tvShows: MediaItem[] = [
  {
    id: 't1',
    title: '星辰大海',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20tv%20series%20poster%20with%20spaceship%20silhouette%20before%20a%20giant%20rose%20colored%20planet%2C%20soft%20glow%2C%20elegant%20minimal%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=poster-tv-star-ocean&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['科幻', '剧情', '冒险'],
    rating: 8.6,
    director: '楚星河',
    cast: ['陆深', '安澜', '江屿'],
    synopsis: '人类首个星际移民计划启动，一群年轻宇航员踏上未知旅程，在浩瀚星海中追寻文明延续的答案。',
    hits: 189600,
    updatedAt: '2025-10-10',
    episodeCount: 32,
    status: '连载中',
  },
  {
    id: 't2',
    title: '岁月长歌',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20tv%20poster%20with%20vintage%20Chinese%20town%20street%20in%20warm%20sunset%2C%20soft%20pink%20haze%2C%20nostalgic%20elegant%20minimal%20artistic%20style&width=800&height=1200&seq=poster-tv-years-song&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['年代', '剧情', '家庭'],
    rating: 8.9,
    director: '南怀瑾',
    cast: ['周正道', '林素梅', '方建国'],
    synopsis: '一个普通家庭跨越四十年风雨，用最平凡的生活书写了一曲动人的岁月长歌，也见证了一座城市的变迁。',
    hits: 167300,
    updatedAt: '2025-09-20',
    episodeCount: 40,
    status: '已完结',
  },
  {
    id: 't3',
    title: '都市迷情',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20tv%20poster%20of%20a%20modern%20city%20at%20night%20with%20soft%20pink%20neon%20glow%2C%20elegant%20atmospheric%20minimal%20artistic%20style%2C%20high%20detail&width=800&height=1200&seq=poster-tv-city-love&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['都市', '情感', '剧情'],
    rating: 8.1,
    director: '温以宁',
    cast: ['贺兰', '苏黎', '顾城'],
    synopsis: '四个在都市中打拼的年轻人，在事业与情感的交叉路口不断选择，也重新定义了属于这个时代的关系。',
    hits: 132400,
    updatedAt: '2025-10-06',
    episodeCount: 36,
    status: '连载中',
  },
  {
    id: 't4',
    title: '侠影江湖',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20wuxia%20martial%20arts%20tv%20poster%20of%20a%20swordsman%20silhouette%20in%20misty%20bamboo%20forest%2C%20soft%20rose%20mist%20and%20dappled%20light%2C%20elegant%20minimal%20painterly%20style&width=800&height=1200&seq=poster-tv-wuxia&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['武侠', '古装', '动作'],
    rating: 8.5,
    director: '欧阳锋刃',
    cast: ['萧无涯', '陆雪衣', '苏惊鸿'],
    synopsis: '少年剑客背负师门血仇踏入江湖，在一次次抉择中逐渐明白，真正的侠义从不是快意恩仇，而是守护苍生。',
    hits: 145100,
    updatedAt: '2025-09-18',
    episodeCount: 44,
    status: '已完结',
  },
  {
    id: 't5',
    title: '法医手记',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20investigation%20tv%20poster%20with%20laboratory%20light%20and%20soft%20pink%20ambient%20glow%2C%20clinical%20elegant%20minimal%20atmospheric%20style%2C%20high%20detail&width=800&height=1200&seq=poster-tv-forensic&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['悬疑', '探案', '剧情'],
    rating: 8.7,
    director: '裴知微',
    cast: ['沈砚', '柯以宁', '白天明'],
    synopsis: '一位冷静严谨的法医与一位热血刑警搭档，凭借蛛丝马迹还原真相，让每一个沉默的逝者都能被听见。',
    hits: 158900,
    updatedAt: '2025-10-09',
    episodeCount: 30,
    status: '连载中',
  },
  {
    id: 't6',
    title: '青春纪事',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20youth%20campus%20tv%20poster%20with%20school%20playground%20under%20soft%20sunlight%2C%20blooming%20pink%20trees%2C%20fresh%20nostalgic%20minimal%20artistic%20style&width=800&height=1200&seq=poster-tv-youth-campus&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['青春', '校园', '爱情'],
    rating: 7.9,
    director: '林清越',
    cast: ['夏一课', '陈小雨', '许扬'],
    synopsis: '一群高中生在最后的青春里，经历友情、懵懂的爱恋与成长的阵痛，也留下了属于那个夏天的独家记忆。',
    hits: 97600,
    updatedAt: '2025-09-10',
    episodeCount: 28,
    status: '已完结',
  },
  {
    id: 't7',
    title: '商海风云',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20business%20drama%20tv%20poster%20of%20a%20modern%20skyscraper%20glass%20facade%20at%20dusk%2C%20soft%20pink%20and%20mauve%20sky%20reflections%2C%20elegant%20minimal%20style&width=800&height=1200&seq=poster-tv-business&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['商战', '都市', '剧情'],
    rating: 8.3,
    director: '柯明哲',
    cast: ['高启明', '邱旻', '洛天'],
    synopsis: '一个白手起家的创业者卷入资本博弈，在商海沉浮中守住初心，也看清了财富背后真正珍贵的东西。',
    hits: 121800,
    updatedAt: '2025-10-03',
    episodeCount: 34,
    status: '连载中',
  },
  {
    id: 't8',
    title: '云端恋人',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sweet%20romance%20tv%20poster%20with%20soft%20clouds%20and%20pink%20sunset%20sky%2C%20two%20distant%20silhouettes%2C%20dreamy%20gentle%20minimal%20artistic%20style&width=800&height=1200&seq=poster-tv-cloud-love&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['甜宠', '职场', '爱情'],
    rating: 7.7,
    director: '苏语柔',
    cast: ['云舒', '陆时宴', '简一'],
    synopsis: '一位航空工程师与一位旅行博主因一场延误结缘，两个原本平行的世界在云层之上慢慢靠近。',
    hits: 105400,
    updatedAt: '2025-09-24',
    episodeCount: 24,
    status: '已完结',
  },
  {
    id: 't9',
    title: '名门望族',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20family%20saga%20tv%20poster%20of%20an%20old%20Chinese%20mansion%20courtyard%20at%20golden%20hour%2C%20warm%20rose%20light%2C%20elegant%20painterly%20minimal%20style&width=800&height=1200&seq=poster-tv-aristocrat&orientation=portrait',
    year: 2023,
    region: '中国',
    genres: ['家族', '历史', '剧情'],
    rating: 8.8,
    director: '慕容迟',
    cast: ['沈崇文', '容婉君', '纪承业'],
    synopsis: '百年家族的兴衰起落，三代人的恩怨纠葛，在大时代的洪流中，谁又能真正守住祖辈留下的荣光。',
    hits: 139700,
    updatedAt: '2025-08-25',
    episodeCount: 46,
    status: '已完结',
  },
  {
    id: 't10',
    title: '悬壶济世',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20tv%20poster%20with%20hospital%20corridor%20soft%20light%2C%20calm%20warm%20pink%20tones%2C%20clinical%20elegant%20minimal%20atmospheric%20style&width=800&height=1200&seq=poster-tv-doctor&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['医疗', '都市', '剧情'],
    rating: 8.4,
    director: '白济生',
    cast: ['顾悬壶', '林青囊', '沈愈'],
    synopsis: '一位坚持理想的主治医师在现实的医疗体系中艰难前行，用一次次全力以赴诠释了医者仁心的重量。',
    hits: 118300,
    updatedAt: '2025-09-16',
    episodeCount: 38,
    status: '已完结',
  },
  {
    id: 't11',
    title: '破晓之光',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20spy%20period%20drama%20tv%20poster%20of%20a%20silhouette%20in%20a%20dim%20train%20station%20at%20dawn%2C%20soft%20pink%20morning%20mist%2C%20tense%20elegant%20minimal%20style&width=800&height=1200&seq=poster-tv-dawn-spy&orientation=portrait',
    year: 2025,
    region: '中国',
    genres: ['谍战', '年代', '悬疑'],
    rating: 8.6,
    director: '黎明澈',
    cast: ['程雾', '苏见月', '祁夜'],
    synopsis: '黎明前最黑暗的时刻，一位隐藏身份的潜伏者游走于敌我之间，用信仰点亮了走向光明的路。',
    hits: 147200,
    updatedAt: '2025-10-07',
    episodeCount: 42,
    status: '连载中',
  },
  {
    id: 't12',
    title: '深夜食堂',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20healing%20food%20drama%20tv%20poster%20of%20a%20cozy%20small%20restaurant%20at%20night%2C%20warm%20pink%20lantern%20glow%2C%20soft%20nostalgic%20minimal%20artistic%20style&width=800&height=1200&seq=poster-tv-night-kitchen&orientation=portrait',
    year: 2024,
    region: '中国',
    genres: ['治愈', '美食', '都市'],
    rating: 8.5,
    director: '夜未央',
    cast: ['老周', '阿珍', '小林'],
    synopsis: '城市深夜的一间小食堂，一道道家常菜背后，是一位位食客不为人知的故事，温暖着每一个夜归的人。',
    hits: 92600,
    updatedAt: '2025-09-08',
    episodeCount: 20,
    status: '已完结',
  },
];

export const allMedia: MediaItem[] = [...movies, ...tvShows];